/**
 * @fileoverview
 * Local/Session Storage Keys Constants
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

export const STORAGE_KEYS = {
  // Authentication
  ACCESS_TOKEN: 'super_admin_token',
  REFRESH_TOKEN: 'super_admin_refresh_token',
  USER_DATA: 'super_admin_user',
  /** Cross-tab last user activity epoch (ms), throttled writes */
  LAST_USER_ACTIVITY_MS: 'ews_super_admin_last_activity_ms',
  /** When inactivity warning is shown, epoch (ms) at which the session auto-ends */
  SESSION_WARNING_DEADLINE_MS: 'ews_super_admin_warn_deadline_ms',
} as const;
